/**
 * 权限点 key 常量（前后端唯一真源）。
 * 产品功能基线自 v1.35.8 起（见 backend/utils/permissionBaseline.js）；
 * 新增 key 时更新目录展示名与自动化基线测试。
 */

export const PERM = Object.freeze({
	// ---------- 菜单入口（menu 型） ----------
	MENU_DASHBOARD_STAT_CARDS: 'erp.menu.dashboard.stat_cards',
	MENU_DASHBOARD_HOME_CHARTS: 'erp.menu.dashboard.home_charts',
	MENU_DASHBOARD_OVERDUE: 'erp.menu.dashboard.overdue',
	MENU_DASHBOARD_MENU: 'erp.menu.dashboard.menu',
	MENU_DASHBOARD_SEARCH: 'erp.menu.dashboard.search',
	MENU_ORDER_CREATE: 'erp.menu.order.create',
	MENU_ORDER_DRAFT: 'erp.menu.order.draft',
	MENU_ORDER_LIST: 'erp.menu.order.list',
	MENU_STATISTICS_VIEW: 'erp.menu.statistics.view',
	MENU_CUSTOMER_LIST: 'erp.menu.customer.list',
	MENU_PRODUCT_LIST: 'erp.menu.product.list',
	MENU_PROFILE: 'erp.menu.profile',
	MENU_PERFORMANCE_LIST: 'erp.menu.performance.list',
	MENU_APPROVAL_APPLICATIONS: 'erp.menu.approval.applications',
	MENU_APPROVAL_RECORDS: 'erp.menu.approval.records',
	MENU_NOTIFICATION_LIST: 'erp.menu.notification.list',
	NOTIFICATION_QUERY: 'erp.notification.query',
	NOTIFICATION_UPDATE: 'erp.notification.update',
	MENU_USER_LIST: 'erp.menu.user.list',
	MENU_LOGINLOG_LIST: 'erp.menu.loginlog.list',
	MENU_BRAND_LIST: 'erp.menu.brand.list',
	MENU_SUPPLIER_LIST: 'erp.menu.supplier.list',
	MENU_ORDER_QUOTATION: 'erp.menu.order.quotation',

	// ---------- 仪表盘：待办 Tab（入口型） ----------
	DASHBOARD_ORDER_APPROVING: 'erp.dashboard.order.approving',
	DASHBOARD_ORDER_PREPAYMENT: 'erp.dashboard.order.prepayment',
	/** 除管理员外，勾上后待签约列表与全局搜索看全部待签约，这些订单可以打开并发货 */
	DASHBOARD_ORDER_CONTRACT: 'erp.dashboard.order.contract',
	DASHBOARD_ORDER_DELIVERING: 'erp.dashboard.order.delivering',
	DASHBOARD_ORDER_ACCEPTING: 'erp.dashboard.order.accepting',
	DASHBOARD_ORDER_AR: 'erp.dashboard.order.ar',
	DASHBOARD_ORDER_APPLING: 'erp.dashboard.order.appling',
	DASHBOARD_ORDER_REJECTED: 'erp.dashboard.order.rejected',
	/** 除管理员外，勾上后进程（采购）列表与全局搜索看全部待验收，这些订单可以打开 */
	DASHBOARD_ORDER_PROCESSING_BUYER: 'erp.dashboard.order.processing.buyer',
	/** 除管理员外，勾上后进程（财务）列表与全局搜索看全部已审批且未完成的订单 */
	DASHBOARD_ORDER_PROCESSING_FINANCE: 'erp.dashboard.order.processing.finance',
	DASHBOARD_ORDER_FINAL_COST_VERIFICATION: 'erp.dashboard.order.final_cost_verification',

	/** 超期统计里的子入口 */
	DASHBOARD_STATEMENT_PDF_EXPORT: 'erp.dashboard.statementPdf.export',

	// ---------- 统计 ----------
	STATISTICS_ORDER_QUERY: 'erp.statistics.order.query',
	STATISTICS_FINANCE_QUERY: 'erp.statistics.finance.query',
	STATISTICS_PERFORMANCE_QUERY: 'erp.statistics.performance.query',
	STATISTICS_DASHBOARD_CHARTS_QUERY: 'erp.statistics.dashboardCharts.query',
	STATISTICS_DASHBOARD_CHARTS_EDIT: 'erp.statistics.dashboardCharts.edit',
	/** 可按销售员/助理筛选。不能超出订单可见范围（主管树或已审批全库） */
	STATISTICS_TEAM_FILTER: 'erp.statistics.teamFilter',
	STATISTICS_COMPARE: 'erp.statistics.compare',
	STATISTICS_OVERDUE_QUERY: 'erp.statistics.overdue.query',
	/** 销售看板界面标记。数据范围不由它决定，始终跟订单可见范围 */
	STATISTICS_SCOPE_OWN: 'erp.statistics.scope.own',

	// ---------- 订单 ----------
	ORDER_CREATE: 'erp.order.create',
	ORDER_DELETE: 'erp.order.delete',
	ORDER_QUERY: 'erp.order.query',
	ORDER_DELIVERY: 'erp.order.delivery',
	ORDER_ACCEPT: 'erp.order.accept',
	ORDER_PAYMENT_RECEIVE: 'erp.order.payment.receive',
	ORDER_DRAFT_CREATE: 'erp.order.draft.create',
	ORDER_DRAFT_UPDATE: 'erp.order.draft.update',
	ORDER_DRAFT_DELETE: 'erp.order.draft.delete',
	ORDER_DRAFT_QUERY: 'erp.order.draft.query',
	ORDER_QUOTATION_CREATE: 'erp.order.quotation.create',
	ORDER_QUOTATION_QUERY: 'erp.order.quotation.query',
	ORDER_QUOTATION_UPDATE: 'erp.order.quotation.update',
	ORDER_QUOTATION_DUPLICATE: 'erp.order.quotation.duplicate',
	ORDER_QUOTATION_VOID: 'erp.order.quotation.void',
	ORDER_QUOTATION_DELETE: 'erp.order.quotation.delete',
	ORDER_BRAND_CORRECTION_EDIT: 'erp.order.brandCorrection.edit',
	ORDER_PERFORMANCE_SETTLEMENT_VIEW: 'erp.order.performanceSettlement.view',
	/** 全部订单 / 全部草稿（租户管理员；按 user.company 过滤） */
	ORDER_QUERY_TENANT_ALL: 'erp.order.query.tenantAll',
	ORDER_DRAFT_QUERY_TENANT_ALL: 'erp.order.draft.query.tenantAll',
	/** 跨租户全量订单/草稿（仅 platform 角色） */
	ORDER_QUERY_ALL: 'erp.order.query.all',
	ORDER_DRAFT_QUERY_ALL: 'erp.order.draft.query.all',
	ORDER_FINAL_COST_CONFIRM: 'erp.order.finalCost.confirm',
	ORDER_FINAL_COST_ADJUST: 'erp.order.finalCost.adjust',
	ORDER_FINAL_COST_APPLY: 'erp.order.finalCost.apply',

	// ---------- 客户 ----------
	CUSTOMER_CREATE: 'erp.customer.create',
	CUSTOMER_UPDATE: 'erp.customer.update',
	CUSTOMER_DELETE: 'erp.customer.delete',
	CUSTOMER_QUERY: 'erp.customer.query',

	// ---------- 产品 ----------
	PRODUCT_CREATE: 'erp.product.create',
	PRODUCT_UPDATE: 'erp.product.update',
	PRODUCT_DELETE: 'erp.product.delete',
	PRODUCT_QUERY: 'erp.product.query',

	// ---------- 品牌 ----------
	BRAND_CREATE: 'erp.brand.create',
	BRAND_UPDATE: 'erp.brand.update',
	BRAND_DELETE: 'erp.brand.delete',
	BRAND_QUERY: 'erp.brand.query',

	// ---------- 供应商 ----------
	SUPPLIER_CREATE: 'erp.supplier.create',
	SUPPLIER_QUERY: 'erp.supplier.query',

	// ---------- 用户 ----------
	USER_CREATE: 'erp.user.create',
	USER_UPDATE: 'erp.user.update',
	USER_DELETE: 'erp.user.delete',
	USER_QUERY: 'erp.user.query',
	LOGINLOG_CREATE: 'erp.loginlog.create',

	// ---------- 组织 ----------
	ORG_DEPARTMENT_QUERY: 'erp.org.department.query',
	ORG_DEPARTMENT_CREATE: 'erp.org.department.create',
	ORG_DEPARTMENT_UPDATE: 'erp.org.department.update',
	ORG_DEPARTMENT_DELETE: 'erp.org.department.delete',
	ORG_GROUP_QUERY: 'erp.org.group.query',
	ORG_GROUP_CREATE: 'erp.org.group.create',
	ORG_GROUP_UPDATE: 'erp.org.group.update',
	ORG_GROUP_DELETE: 'erp.org.group.delete',

	// ---------- 绩效 ----------
	PERFORMANCE_CREATE: 'erp.performance.create',
	PERFORMANCE_UPDATE: 'erp.performance.update',
	PERFORMANCE_DELETE: 'erp.performance.delete',
	PERFORMANCE_QUERY: 'erp.performance.query',
	PERFORMANCE_BULK_REMATCH: 'erp.performance.bulkRematch',

	// ---------- 审批 ----------
	/** 查询待审批（全租户）。治理类，仅租户管理员默认持有 */
	APPROVAL_QUERY_TENANT_ALL: 'erp.approval.query.tenantAll',
	APPROVAL_CUSTOMER_INITIATE: 'erp.approval.customer.initiate',
	APPROVAL_CUSTOMER_EXECUTE: 'erp.approval.customer.execute',
	APPROVAL_ORDER_INITIATE: 'erp.approval.order.initiate',
	APPROVAL_ORDER_EXECUTE: 'erp.approval.order.execute',
	/** 最终成本修正的通过/驳回。与下单审批分开；确认/调整/应用仍用 ORDER_FINAL_COST_* */
	APPROVAL_FINAL_COST_EXECUTE: 'erp.approval.finalCost.execute',
	APPROVAL_QUOTA_INITIATE: 'erp.approval.quota.initiate',
	APPROVAL_QUOTA_EXECUTE: 'erp.approval.quota.execute',

	// ---------- 字段权限 ----------
	PRODUCT_PURCHASING_PRICE_VIEW: 'erp.product.purchasingPrice.view',
	PRODUCT_PURCHASING_PRICE_EDIT: 'erp.product.purchasingPrice.edit',
	PRODUCT_MIN_SELLING_PRICE_VIEW: 'erp.product.minimumSellingPrice.view',
	PRODUCT_MIN_SELLING_PRICE_EDIT: 'erp.product.minimumSellingPrice.edit',
});

/** 所有合法权限点字符串（用于校验、快照合成） */
export const ALL_PERMISSIONS = Object.freeze(Object.values(PERM));

/** 快速校验：传入字符串是否是已登记权限点 */
export const isKnownPermission = (key) => ALL_PERMISSIONS.includes(key);

export default PERM;
